module.exports = __webpack_public_path__ + "media/boom.550be808.wav";